import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { map, Observable } from 'rxjs';
import { SearchResultsCommand } from '../../../../core/commands/search-results.command';
import { WorksitesCommand } from '../../../../core/commands/worksites.command';
import { Country } from '../../../../core/models/country.model';
import { ListCompany } from '../../../../core/models/list-company.model';
import { ListWorksite } from '../../../../core/models/list-worksite.model';
import { SearchResultsRepository } from '../../../../core/repositories/search-result.repository';

@UntilDestroy()
@Component({
  selector: 'lib-search-result',
  templateUrl: './search-result.component.html',
  styleUrls: ['./search-result.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SearchResultComponent implements OnInit {
  @Input() result: ListCompany[];
  @Input() totalHits: number;
  @Input() minified: boolean;
  @Input() countries: Country[];
  @Input() alreadySelectedWorksites: string[];
  @Input() isFinancierSearch: false;
  @Input() alreadySelectedFinanciers: string[];

  @Output() createWorksite = new EventEmitter<ListCompany>();
  @Output() createCompanyAndWorksite = new EventEmitter<void>();
  @Output() selectWorksite = new EventEmitter<ListWorksite>();

  listCompanies: ListCompany[];
  isProjectPart$: Observable<boolean>;
  activeSearchResult$: Observable<ListCompany>;

  constructor(
    private route: ActivatedRoute,
    private worksitesCommand: WorksitesCommand,
    private searchResultsCommand: SearchResultsCommand,
    private searchResultsRepository: SearchResultsRepository,
  ) {}

  ngOnInit() {
    this.isProjectPart$ = this.route.queryParams.pipe(
      map((params) => (params['isProjectPart'] === 'true' ? true : false)),
    );

    if (this.minified) {
      this.activeSearchResult$ = this.searchResultsRepository.active$;
    }
    this.listCompanies = this.searchResultsRepository.getAll();
  }

  expandAll() {
    for (const company of this.listCompanies) {
      this.searchResultsCommand.updateIsCollapsedParameter(
        company.providerId,
        false,
      );
    }
  }

  minimizeAll() {
    for (const company of this.listCompanies) {
      this.searchResultsCommand.updateIsCollapsedParameter(
        company.providerId,
        true,
      );
    }
  }

  onSelectWorksite(worksite: ListWorksite) {
    this.selectWorksite.emit(worksite);
  }

  onCreateWorksite(company: ListCompany) {
    this.createWorksite.emit(company);
  }

  onCreateCompanyAndWorksite() {
    this.createCompanyAndWorksite.emit(undefined);
  }

  extendWorksites(data) {
    const { worksite, companyId, loader } = data;
    this.worksitesCommand
      .extendWorksites(
        worksite.identicalWorksites.map((x) => x.providerId),
        worksite.providerId,
        companyId,
      )
      .pipe(untilDestroyed(this))
      .subscribe(() => {
        loader.remove();
      });
  }
}
